import { apiFetch } from "./utils";
import { API_ENDPOINTS } from "../config/api";
import { GeneralRanking, RankingStoricoTop3 } from "../types";

export const getGeneralRanking = async (seasonId: number): Promise<GeneralRanking[]> => {
  const params = new URLSearchParams();
  params.append('season_id', seasonId.toString());
  return apiFetch(`${API_ENDPOINTS.SEASON_GENERAL_RANKING}?${params.toString()}`);
};

export const getGeneralRankingTop3 = async (): Promise<RankingStoricoTop3> => {
  return apiFetch(`${API_ENDPOINTS.ALL_GENERAL_RANKING}`);
};
